<div class="card box-shadow-hover my-2" @slideIn>
  <div class="card-body">
    <div class="row">
      <div class="col">
        <div class="d-flex">
          <div class="missions-header-border mr-2"></div>
          <div class="missions-header">
            {{ 'Mission_view.billing.due_payment'|translate }}
          </div>
        </div>
        <table class="table table-material table-responsive-sm">
          <thead class="thead-normal">
          <tr>
            <th class="text-left">
              {{ 'Mission_view.billing.' + (billings.duePaymentByDate | booleanFormat: ["due_date", "event"])|translate }}
            </th>

            <th class="text-right">
              {{ "Mission_view.billing.amount" | translate }}
            </th>

            <th class="text-right">
              {{ 'Mission_view.billing.status.label' | translate }}
            </th>
          </tr>
          </thead>

          <tbody>
          <tr *ngFor="let payment of billings.dueDatePayment; let i = index">
            <td class="text-left" *ngIf="billings.duePaymentByDate">
              {{ payment.dueDate | localizedDate }}
            </td>
            <td class="text-left" *ngIf="!billings.duePaymentByDate">
              {{ payment.event }}
            </td>
            <td
              class="text-right"
              [ngClass]="{'text-highlight': payment.status !== DuePaymentStatus.CANCELLED, 'text-decoration-line-through': payment.status === DuePaymentStatus.CANCELLED, 'text-muted': payment.status === DuePaymentStatus.CANCELLED}"
            >
              {{ payment.amount | localizedCurrency:billings.currency }}
            </td>
            <td class="text-right">
              <span *ngIf="payment.status === DuePaymentStatus.SUBMITTED && billings.duePaymentByDate && isDateInThePast(payment.dueDate)"
                    class="badge badge-warning">
                  {{'Mission_view.billing.status.LATE' | translate}}
              </span>
              <span *ngIf="payment.status === DuePaymentStatus.VALIDATED" class="badge badge-success">
                  {{'Mission_view.billing.status.VALIDATED' | translate}}
              </span>
              <span *ngIf="payment.status === DuePaymentStatus.CANCELLED" class="badge badge-purple">
                  {{'Mission_view.billing.status.CANCELLED' | translate}}
              </span>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td class="text-left font-weight-strong">{{ 'Mission_view.billing.total' | translate }}</td>
            <td class="text-right text-highlight font-weight-strong">
              {{ getTotalDuePayment() | localizedCurrency:billings.currency }}
            </td>
            <td></td>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>
